// extracted by mini-css-extract-plugin
export default {"body":"add-product-modal_body__H6fMK"};